import { ParametersItem, ProjectParameterItem } from 'ducks/types/store-types';

export const handleParameter = (data: (ParametersItem | ProjectParameterItem)[]) => {
  const res = data.map((d) => {
    const parameter = {
      parameter_name: d.parameter_name,
      parameter_direction_id: d.parameter_direction_id,
      parameter_method_id: d.parameter_method_id,
      is_required: d.is_required,
      is_encrypted: d.is_encrypted,
      parameter_value: d.parameter_value,
      description: d.description,
      command_line_prefix: d.command_line_prefix,
      command_line_assignment_char: d.command_line_assignment_char,
      command_line_escaped: d.command_line_escaped,
      command_line_ignore_name: d.command_line_ignore_name,
      reference_type_id: d.reference_type_id,
      reference_id: d.reference_id,
      reference_parameter_name: d.reference_parameter_name,
    };

    if ('parameter_name_old' in d) {
      return {
        ...parameter,
        parameter_name_old: d.parameter_name_old,
      };
    }

    return {
      ...parameter,
      parameter_name_old: '',
    };
  });

  return res;
};
